import { Injectable } from '@angular/core';
import { Selector, State, StateToken } from '@ngxs/store';

interface MaintenanceType {
  startDate: number;
  endDate: number;
  site: boolean;
  api: boolean;
}

const MaintenanceStateToken = new StateToken<MaintenanceType>('maintenance');

@State({
  name: MaintenanceStateToken,
  defaults: {
    startDate: new Date('2022-02-11T18:15:00').getTime() / 1000,
    endDate: new Date('2022-02-12T15:00:00').getTime() / 1000,
    site: true,
    api: false,
  },
})
@Injectable()
export class MaintenanceState {
  @Selector([MaintenanceState])
  static startDate(state: MaintenanceType): number {
    return state.startDate;
  }

  @Selector([MaintenanceState])
  static endDate(state: MaintenanceType): number {
    return state.endDate;
  }

  @Selector([MaintenanceState.endDate])
  static endDateAsDateString(endDate: number): string {
    const dateFormatOptions: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    };
    return new Intl.DateTimeFormat('fr-FR', dateFormatOptions).format(endDate * 1000);
  }

  @Selector([MaintenanceState])
  static site(state: MaintenanceType): boolean {
    return state.site;
  }

  @Selector([MaintenanceState])
  static api(state: MaintenanceType): boolean {
    return state.api;
  }

  @Selector([MaintenanceState.startDate, MaintenanceState.endDate])
  static underMaintenance(startDate: number, endDate: number): boolean {
    const date = Math.round(Date.now() / 1000);
    return date > startDate && date < endDate;
  }

  @Selector([MaintenanceState.underMaintenance, MaintenanceState.site])
  static siteUnderMaintenance(underMaintenance: boolean, site: boolean): boolean {
    return underMaintenance && site;
  }

  @Selector([MaintenanceState.underMaintenance, MaintenanceState.api])
  static apiUnderMaintenance(underMaintenance: boolean, api: boolean): boolean {
    return underMaintenance && api;
  }
}
